<template>
  <div
    v-if="visible"
    class="gtc-overlay"
    @keydown.esc="choose('new')"
    tabindex="0"
  >
    <div class="gtc-panel">
      <div class="gtc-header">
        <i class="fa-solid fa-layer-group gtc-header-icon"></i>
        <div>
          <div class="gtc-title">Configurar Grupos e Subgrupos</div>
          <div class="gtc-subtitle">Como deseja iniciar a organização dos itens desta locação?</div>
        </div>
      </div>

      <div class="gtc-options">
        <button
          class="gtc-card"
          @click="choose('without-group')"
        >
          <i class="fa-solid fa-hashtag gtc-card-icon gtc-icon-amber"></i>
          <span class="gtc-card-title">Sem Grupo/Subgrupo</span>
          <span class="gtc-card-desc">Crie a proposta sem grupo e subgrupo.</span>

        </button>

        <button
          class="gtc-card"
          @click="choose('template')"
        >
          <i class="fa-solid fa-file-import gtc-card-icon gtc-icon-blue"></i>
          <span class="gtc-card-title">Modelo</span>
          <span class="gtc-card-desc">Selecione um modelo previamente cadastrado.</span>
        </button>

        <button
          class="gtc-card"
          @click="choose('new')"
        >
          <i class="fa-solid fa-plus-circle gtc-card-icon gtc-icon-green"></i>
          <span class="gtc-card-title">Começar do Zero</span>
          <span class="gtc-card-desc">Crie os grupos e subgrupos do zero.</span>

        </button>
      </div>
    </div>
    <div
      class="gtc-backdrop"
      @click="choose('new')"
    ></div>
  </div>
</template>

<script>
export default {
  name: "GroupTemplateChoice",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    choose(option) {
      if (option === "template") {
        this.$emit("choose-template");
      } else if (option === "without-group") {
        this.$emit("choose-without-group");
      } else {
        this.$emit("choose-new");
      }
    },
  },
  watch: {
    visible(v) {
      if (v) {
        this.$nextTick(() => {
          this.$el && this.$el.focus && this.$el.focus();
        });
      }
    },
  },
};
</script>

<style scoped>
.gtc-overlay {
  position: fixed;
  inset: 0;
  z-index: 9998;
  display: grid;
  place-items: center;
  outline: none;
}

.gtc-backdrop {
  position: absolute;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
}

.gtc-panel {
  position: relative;
  z-index: 1;
  width: min(720px, 92vw);
  background: #fff;
  border-radius: 18px;
  padding: 28px 28px 24px;
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.22);
  border: 1px solid #e2e8f0;
}

.gtc-header {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 24px;
}

.gtc-header-icon {
  font-size: 28px;
  color: #2563eb;
  flex-shrink: 0;
}

.gtc-title {
  font-size: 17px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.3;
}

.gtc-subtitle {
  font-size: 13px;
  color: #64748b;
  margin-top: 3px;
}

.gtc-options {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}

.gtc-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding: 20px 18px;
  border-radius: 14px;
  border: 2px solid #e2e8f0;
  background: #f8fafc;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.18s ease, box-shadow 0.18s ease,
    background 0.18s ease;
}

.gtc-card:hover {
  border-color: #2563eb;
  background: #eff6ff;
  box-shadow: 0 4px 18px rgba(37, 99, 235, 0.1);
}

.gtc-card:focus-visible {
  outline: 3px solid #2563eb;
  outline-offset: 2px;
}

.gtc-card-icon {
  font-size: 26px;
  margin-bottom: 4px;
}

.gtc-icon-blue {
  color: #2563eb;
}

.gtc-icon-green {
  color: #16a34a;
}

.gtc-icon-amber {
  color: #d97706;
}

.gtc-card-title {
  font-size: 15px;
  font-weight: 700;
  color: #1e293b;
}

.gtc-card-desc {
  font-size: 12px;
  color: #64748b;
  line-height: 1.5;
}

.gtc-card-badge {
  font-size: 11px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 9999px;
  margin-top: 4px;
}

.gtc-badge-blue {
  background: #dbeafe;
  color: #1d4ed8;
}

.gtc-badge-gray {
  background: #f1f5f9;
  color: #475569;
}

@media (max-width: 860px) {
  .gtc-options {
    grid-template-columns: 1fr;
  }
}
</style>
